import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=c73345a6&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=c73345a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73345a6",
  null
  
)

export default component.exports